
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { SystemQuery } from 'enums/SystemQuery';
import { PoolModel } from './Entities.GormCrm.Pool';
import { Model, ModelProperty } from 'models/Model';


export class QueryModel extends Model<QueryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'system', type: 'SystemQuery' },
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'data', type: 'string' },
		{ name: 'description', type: 'string' },
		{ name: 'pools', type: 'PoolModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new PoolModel }, properties: () => { return PoolModel.classProperties } }
	];
	[key: string]: any;
	
	public system?: SystemQuery;
	public id?: string;
	public name: string;
	public created?: Date;
	public deleted?: Date;
	public data: string;
	public description: string;
	public pools: PoolModel[];
    
	constructor(){
		super();
		this.system = undefined;
		this.id = undefined;
		this.name = '';
		this.created = undefined;
		this.deleted = undefined;
		this.data = '';
		this.description = '';
		this.pools = [];
		
	}
	getProperties(){
		return QueryModel.classProperties;
	}
}

